"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
const presence_service_g_1 = require("./presence-service.g");
class PresenceService extends presence_service_g_1.PresenceService {
    getPresentitiesBy(params) {
        return this.getPresentities({ items: this.extractIds(params) });
    }
    extractPresentities(params) {
        return utils_1.Utils.getItemsFromCollection(params.collection);
    }
    extractIds(params) {
        const presentities = params.presentities || this.extractPresentities({ collection: params.collection });
        return presentities.map(presentity => presentity.principalId);
    }
}
exports.PresenceService = PresenceService;
